import { ReactNode } from 'react';
import AntdNotification from 'antd/lib/notification';

/**
 * {@docCategory Notification}
 */
export interface NotificationProps {
   /**
    * The title of the notification (required).
    */
   title: ReactNode;

   /**
    * The content of the notification (required).
    */
   content: ReactNode;

   /**
    * The id of the notification.
    */
   notificationId?: string;

   /**
    * The time in seconds before the Notification is closed. When set to 0, it will never be closed
    * automatically.
    * @defaultvalue 4.5
    */
   duration?: number | null;

   /**
    * Position of Notification, can be one of topLeft topRight bottomLeft bottomRight.
    * @defaultvalue topRight
    */
   placement?: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';

   /**
    * Icon to display.
    */
   icon?: ReactNode;

   /**
    * Specify a function that will be called when the notification is clicked
    */
   onClick?: () => void;

   /**
    * Trigger when notification closed
    */
   onClose?: () => void;
}

export class Notification {
   static error(options: NotificationProps) {
      AntdNotification.error({
                                message: options.title,
                                description: options.content,
                                key: options.notificationId,
                                duration: options.duration,
                                placement: options.placement,
                                icon: options.icon,
                                onClick: options.onClick,
                                onClose: options.onClose
                             });
   }

   static info(options: NotificationProps) {
      AntdNotification.info({
                               message: options.title,
                               description: options.content,
                               key: options.notificationId,
                               duration: options.duration,
                               placement: options.placement,
                               icon: options.icon,
                               onClick: options.onClick,
                               onClose: options.onClose
                            });
   }

   static success(options: NotificationProps) {
      AntdNotification.success({
                                  message: options.title,
                                  description: options.content,
                                  key: options.notificationId,
                                  duration: options.duration,
                                  placement: options.placement,
                                  icon: options.icon,
                                  onClick: options.onClick,
                                  onClose: options.onClose
                               });
   }

   static warning(options: NotificationProps) {
      AntdNotification.warning({
                                  message: options.title,
                                  description: options.content,
                                  key: options.notificationId,
                                  duration: options.duration,
                                  placement: options.placement,
                                  icon: options.icon,
                                  onClick: options.onClick,
                                  onClose: options.onClose
                               });
   }

   static close(notificationId: string) {
      AntdNotification.close(notificationId);
   }

   static closeAll() {
      AntdNotification.destroy();
   }
}
